/**
 * Redux 스토어 설정
 *
 * 잔류물질안전정보시스템 v3의 전역 상태 관리 스토어.
 * Redux Toolkit의 configureStore를 사용하여 구성하며,
 * 인증(auth) 리듀서만 포함한다.
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  // 개발 환경에서만 DevTools 활성화
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
